import { ComponentType, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { warrantService } from "../../api/services/warrant.service";

export const AdminGuard = ({ component: Component }: { component: ComponentType<any> }) => {
  const [isAdmin, setIsAdmin] = useState<boolean | null>(null);

  useEffect(() => {
    warrantService
      .isCurrentUserAdmin()
      .then(setIsAdmin)
      .catch(() => setIsAdmin(false));
  }, []);

  if (isAdmin === null) {
    return <div>Loading...</div>;
  }

  return isAdmin ? <Component /> : <Navigate to="/" />;
};
